// używane w module authentication
// src/app/pages/authentication

export class loginAccount {
  username: string;
  password: string;
}

export class unlockAccount {
  password: string;
}

export class forgetPass{
  email: string;
  accountCity: string;
}

export class resetPass{
  newPassword: string;
  email: string;
  temporaryKey: string;
}

export interface IAccount {
  // Account TAB
  username?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
};

export interface IEmail {
  // Email & password TAB
  password?: string;
};

export interface IAddress {
  // Address TAB
  country?: any;
  city?: string;
  zip?: string;
  street?: string;
};

export class AccountRegister{
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  countryId: number;
  city?: string;
  zipCode?: string;
  address?: string;
  company?: string;
  about?: string;
}